import { render, staticRenderFns } from "./ProductBulkEdits.vue?vue&type=template&id=3a752186"
import script from "./ProductBulkEdits.vue?vue&type=script&lang=js"
export * from "./ProductBulkEdits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports